import exceljs from "exceljs";
import { saveAs } from "file-saver";

import { useAuthStore, type User } from "src/components/main/authStore";
import { useUiStore } from "src/components/main/uiStore";
import {
    MyDate,
    mimeTypeMap,
} from "src/components/common/functions";
import type { ReportRecord } from "./types";

type ExportProps = {
    filterUserList: ReportRecord[];
};

export default function Export({ filterUserList }: ExportProps) {
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const user = useAuthStore(state => state.user) as User;

    const exportFunc = () => {
        if (!filterUserList.length) {
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", { views: [{ showGridLines: false }] });
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = filterUserList.map(report => [
            report.projectName,
            report.startDate ?? "",
            report.endDate ?? "",
            report.stats,
            report.code,
            report.priority,
            report.pending,
            report.sup,
            report.pdfId ? { formula: `HYPERLINK("https://drive.google.com/uc?export=download&id=${report.pdfId}", "File")` } : "",
            report.reportTech,
            report.status,
        ]);
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Project Name", filterButton: true },
                { name: "Start Date", filterButton: true },
                { name: "End Date", filterButton: true },
                { name: "Stats", filterButton: true },
                { name: "Code", filterButton: true },
                { name: "Priority", filterButton: true },
                { name: "Pending on Other Department", filterButton: true },
                { name: "Supplementary Report", filterButton: true },
                { name: "File", filterButton: true },
                { name: "Report Tech", filterButton: true },
                { name: "Status", filterButton: true },
            ],
            rows,
        });
        void workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `reprots export ${new MyDate().s()}.xlsx`);
            setShowLoader(false);
        });
    };

    return (
        <button type="button" className="btn btn-outline-primary" onClick={exportFunc}>
            Export
        </button>
    );
}
